module.exports = function(app) {
    app.directive('contactUsOnlineForm', function() {

        return{
            restrict: 'A',
            replace: true,
            scope: {},
            templateUrl: 'appTemplate.html/chmhom/directives/contactUsOnlineForm',
            controller: ['$scope', 'services', '$state', 'aemContent', 'brand', function($scope, services, $state, aemContent, brand) {

                $scope.contactUsForm = {
                    firstName : "",
                    lastName : "",
                    umi : "",
                    contactMethod: "",
                    reason : "",
                    comments:"",
                    phone:"",
                    emailAddress: "",
                    mailingAddress: "",
                    address2: "",
                    city: "",
                    state: "",
                    zipcode: "",
                    callPreference: "",
                    brand: brand.current.sharedBrandCode
                };
                var messageTopicContent = "";
                    //Message Topics
                aemContent.get("MBR_CONTACTUS_MESSAGE_TOPICS").then(function(response){

                    var messageTopic = response.split(";");
                    $scope.topics = [];
                    angular.forEach(messageTopic, function(value){
                        var topic = {
                            value: value,
                            label: value
                        }
                        $scope.topics.push(topic);
                    });
                });

                $scope.submit = function(){
                    services.rbsmbl.contactUsService().post($scope.contactUsForm).then(function(response){

                    });
                };
            }]
        };
    });
}